import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useStore = create(
  persist(
    (set) => ({
      user: null, token: null, role: 'user',
      balance: { txc: 0, vgc: 0 }, // always fetched fresh, not persisted
      shortCode: null,
      notifications: [],
      cart: [],
      downloadedModules: ['wallet','transfer','exchange','order','dbux','marketplace','profile','mindstake'],
      kycStatus: 'pending',
      activeRoles: [],
      isDark: false,

      setUser:      u => set({ user: u }),
      setToken:     t => { localStorage.setItem('nexus_token', t); set({ token: t }); },
      setRole:      r => set({ role: r }),
      setBalance:   b => set({ balance: b }),
      setShortCode: c => set({ shortCode: c }),
      setKycStatus: s => set({ kycStatus: s }),
      login: (user, token) => {
        localStorage.setItem('nexus_token', token);
        set({ user, token });
      },
      logout: () => {
        localStorage.removeItem('nexus_token');
        set({ user: null, token: null, balance: { txc: 0, vgc: 0 } });
      },
      addNotification: n => set(s => ({
        notifications: [
          { ...n, id: Date.now(), read: false, time: new Date().toISOString() },
          ...s.notifications
        ].slice(0, 100)
      })),
      markRead: id => set(s => ({
        notifications: s.notifications.map(n => n.id === id ? { ...n, read: true } : n)
      })),
      clearNotifications: () => set({ notifications: [] }),
      addToCart: i => set(s => ({ cart: [...s.cart, { ...i, cartId: Date.now() }] })),
      removeFromCart: id => set(s => ({ cart: s.cart.filter(i => i.cartId !== id) })),
      clearCart: () => set({ cart: [] }),
      setDarkMode: v => set({ isDark: v }),
      activateRole: r => set(s => ({
        activeRoles: [...s.activeRoles.filter(x => x.role_id !== r.role_id), r]
      })),
      deactivateRole: id => set(s => ({
        activeRoles: s.activeRoles.filter(r => r.role_id !== id)
      })),
      downloadModule: id => set(s => ({
        downloadedModules: [...new Set([...s.downloadedModules, id])]
      })),
    }),
    {
      name: 'nexus-v3',
      partialize: s => ({
        user: s.user,
        token: s.token,
        role: s.role,
        shortCode: s.shortCode,
        downloadedModules: s.downloadedModules,
        kycStatus: s.kycStatus,
        activeRoles: s.activeRoles,
        isDark: s.isDark,
      })
    }
  )
);
